// 通用台账表格：首列吸左、表头吸顶、行高 56、整行可点（发货、异常共用；与 OrdersTable 同规格，建议提取）。
import type { ReactNode } from 'react';
import s from './DataTable.module.css';

export type Col<T> = {
  key: string;
  title: ReactNode;
  w?: number;
  align?: 'r' | 'c';
  fix?: boolean;
  render: (row: T) => ReactNode;
};

export function DataTable<T extends { id: string }>({ cols, rows, onRow, selectedId, label, compact = false, fixed = false }: { cols: Col<T>[]; rows: T[]; onRow?: (row: T) => void; selectedId?: string; label: string; compact?: boolean; fixed?: boolean }) {
  const cls = (c: Col<T>) => [c.fix && s.fix, c.align && s[c.align]].filter(Boolean).join(' ') || undefined;
  return (
    <div className={s.scroll}>
      <table className={`${s.tbl} ${compact ? s.compact : ''} ${fixed ? s.fixed : ''}`} aria-label={label}>
        <colgroup>{cols.map((c) => <col key={c.key} style={{ width: c.w }} />)}</colgroup>
        <thead>
          <tr>{cols.map((c) => <th key={c.key} className={cls(c)} scope="col">{c.title}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr
              key={r.id}
              className={r.id === selectedId ? s.sel : undefined}
              onClick={onRow ? () => onRow(r) : undefined}
              onKeyDown={onRow ? (e) => { if (e.key === 'Enter') onRow(r); } : undefined}
              tabIndex={onRow ? 0 : undefined}
            >
              {cols.map((c) => <td key={c.key} className={cls(c)}>{c.render(r)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** 两行单元格：主值 + 12px 灰色副行 */
export function Two({ a, b }: { a: ReactNode; b?: ReactNode }) {
  return (
    <div className={s.two}>
      <span>{a}</span>
      {b != null && b !== '' && <small>{b}</small>}
    </div>
  );
}
